import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import Preloader from '../Preloader/Preloader';
import { useLelyAuth } from '../../auth/useLelyAuth';

export default function RoutesProtector() {
  const { isAuthenticated, user } = useLelyAuth();
  const location = useLocation();

  if (isAuthenticated && !user?.allowltda) {
    return <Navigate to="/access-denied" replace />;
  }

  if (isAuthenticated) {
    return (
      <Suspense fallback={<Preloader />}>
        <Outlet />
      </Suspense>
    );
  }
  localStorage.setItem('redirectUrl', location.pathname + location.search);

  return <Preloader />;
}
